import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/privacy-policy/hero";
import PP from "../components/privacy-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>Dental Implants in Ilkley | Privacy Policy</title>
        <link
          rel="canonical"
          href="https://www.dentalimplants-ilkley.com/privacy-policy"
        />
        <meta
          name="description"
          content="Learn how Dental Implants Ilkley collects, uses, and protects your personal data in line with GDPR by reading our detailed and transparent privacy policy."
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
